module.exports = __webpack_public_path__ + "img/resource-tech-image-45.2269d85e.jpg";